export const Paths = {
  BLANK: "/",
  HOME: "/home",
  DASHBOARD: "/dashboard",
  ROUTE_FLIGHTS_LIST: "/flights",
  ROUTE_FLIGHTS_LIST_DOMESTIC: "/domestic",
  ROUTE_FLIGHTS_SEARCH: "/search",
  ROUTE_PASSENGER_DETAIL: "/review",
  ROUTE_DOMESTIC_PAXFORM: "/paxinfo",
  ROUTE_LOGIN: "/auth/login",
  ROUTE_REGISTER: "/auth/register",
  ABOUT_US: "/about",
  CONTACT_US: "/contact",
  FAQ: "/faq",
  TERMS_AND_CONDITIONS: "/termsandconditions",
  PRIVACY_POLICY: "/privacypolicy",
  DOMESTIC_TICKET_PAGE: "/domesticTicket",
  INT_TICKET_PAGE: "/viewBooking",
  MY_BOOKINGS: "/bookings",
  GENERAL_RULES: "/rules",
  TOUR_SEARCH: "/tour/search",
  TOUR_PACKAGE_DETAIL: "/tour/package/:packageId/:packageName",
  TOUR_DESTINATION_DETAIL: "/tour/destination/:destinationId/:destinationName",
  TOUR_BOOKING: "/tour/booking/:packageId/:pricingId",
  TOUR_BOOKING_DETAIL: "/tour/booking-detail/:bookUID",
  TOUR_PAYMENT: "/tour/payment",
  TOUR_FPAY_SUCCESS: "/tour/fpaysuccess",
};
